// src/utils/textHelpers.js

/**
 * Конвертирует переносы строк в HTML <br> теги
 * @param {string} text - исходный текст
 * @returns {string} - HTML строка с <br> тегами
 */
export function convertNewlinesToBr(text) {
  if (!text || typeof text !== 'string') return '';
  
  return text
    .replace(/\r\n/g, '\n') // нормализуем Windows переносы
    .replace(/\r/g, '\n')   // нормализуем старые Mac переносы
    .split('\n')
    .map(line => line.trim())
    .join('<br />');
}

/**
 * Конвертирует переносы строк в HTML параграфы
 * @param {string} text - исходный текст
 * @returns {string} - HTML строка с <p> тегами
 */
export function convertNewlinesToParagraphs(text) {
  if (!text || typeof text !== 'string') return '';
  
  const paragraphs = text
    .replace(/\r\n/g, '\n') // нормализуем Windows переносы
    .replace(/\r/g, '\n')   // нормализуем старые Mac переносы
    .split('\n\n')          // разделяем по двойным переносам
    .map(p => p.trim())
    .filter(p => p.length > 0);
  
  if (paragraphs.length === 0) return '';
  
  return paragraphs
    .map(p => `<p>${p.replace(/\n/g, '<br />')}</p>`)
    .join('');
}

/**
 * Безопасно отображает текст с переносами строк как HTML
 * @param {string} text - исходный текст
 * @param {boolean} useParagraphs - использовать параграфы вместо br
 * @returns {object} - объект для dangerouslySetInnerHTML
 */
export function renderTextWithLineBreaks(text, useParagraphs = false) {
  const html = useParagraphs 
    ? convertNewlinesToParagraphs(text)
    : convertNewlinesToBr(text);
    
  return { __html: html };
}
/**
 * Форматирует текст с параграфами (алиас для convertNewlinesToParagraphs)
 * @param {string} text - исходный текст
 * @returns {string} - HTML строка с <p> тегами
 */
export function formatTextWithParagraphs(text) {
  return convertNewlinesToParagraphs(text);
}